import { makeStyles } from "@material-ui/core/styles";

export function useExpedientFormStyles() {
  const useStyles = makeStyles((theme) => ({
    button: {
      color: '#004B97',
      fontSize: '0.95rem',
      padding: '0.5rem 1rem',
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
    cardHeader: {
      color: '#FFF',
      backgroundColor: '#004B97',
    },
    cardActions: {
      justifyContent: "flex-end",
      borderTop: '1px solid #F0F0F0',
    },
    chips: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    chip: {
      margin: 2,
    },
    noLabel: {
      marginTop: theme.spacing(3),
    },
    formControl: {
      width: '100%',
    },
    textField: {
      color: '#706E7A',
    }
  }));

  const classes = useStyles();

  return {
    classes,
  };
}
